import { Filter } from './filter';

export class AvailableDataColumn<T> {
    /** convenience function to coerce property name to string */
    public get key(): string {
        return this.name as string;
    }
    /** property name from data element */
    public name: keyof T;
    /** ui-ready label for this data element */
    public title = '';
    /** true if this data element can be hidden/shown */
    public isHidable = true;
    /** true if this data element should be shown default. only applicable if the column is hidable. */
    public isShownByDefault = true;
    /** true if this data element should be searchable */
    public isSearchable = true;
    /** css class to apply to data grid cell. can be string or callback function that is passed the data element */
    public cellClass: string | ((element: T) => string) = '';
    /** css class for icon to display at left side of data grid cell. can be string or callback function that is passed the data element*/
    public iconClass: string | ((element: T) => string) = '';
    /** set the alignment for this cell */
    public cellAlignment: 'left' | 'right' | 'center' = 'left';
    /** title attribute text for display when hovering over data grid cell. can be string or callback function that is passed the data element */
    public tooltipText: string | ((element: T) => string) = '';
    public filter?: Filter;
    /** A function to generate the search string for this column. Defaults to toString if not provided. */
    public searchContentOverride: (element: T) => string;
    /** A function to generate content for this column. Defaults toString. */
    public cellContentOverride: (element: T) => string;

    /** css class to apply to data grid header. */
    public headerCellClass: string | ((element: T) => string) = '';
    /** css class for icon to display at left side of data grid header. */
    public headerIconClass: string | ((element: T) => string) = '';
    /** title attribute text for display when hovering over data grid header. */
    public headerTooltipText = '';
    /** alternate key for sorting */
    public altSortKey: string;
    public get sortKey(): string {
        return this.altSortKey || (this.name as string);
    }
    /** true if this column is sortable */
    public sortable = true;

    constructor(init?: Partial<AvailableDataColumn<T>>) {
        Object.assign(this, init);
    }
}

/** Concatenate values from an element's searchable columns */
export function generateStringToSearch<T>(element: T, columns: AvailableDataColumn<T>[]): string {
    return columns
        .filter(ac => ac.isSearchable)
        .map(ac => (ac.searchContentOverride ? ac.searchContentOverride(element) : element[ac.name]))
        .join(' ');
}
